<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <form ref="serviceForm" @submit.prevent="onFormSubmit">
                        <h3>Добави новина</h3>

                        <div class="form-group">
                            <label>Снимка</label>
                            <input type="file" class="form-control form-control-lg"  ref="file" v-on:change="handleFileUpload()" required>
                        </div>
                        <div class="form-group">
                            <label>Заглавие</label>
                            <input type="text" class="form-control form-control-lg" v-model="news.name" required>
                        </div>

                        <div class="form-group">
                            <label>Описание</label>
                            <div class="editor-wrapper">
                                <vue-editor v-model="news.description"  required></vue-editor>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-primary btn-block">Запази</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                news: {
                    name: '',
                    description: '',
                    image: '',
                    createdAt: Date.now()
                }
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('news').add(this.news).then(() => {
                    alert("Успешно добавена новина!");
                    this.news.name = null;
                    this.news.description = null;
                    this.$refs.file.files[0] = null;
                }).catch((error) => {
                    console.log(error);
                });
            },

            handleFileUpload(){
                const reader = new FileReader();
                reader.readAsDataURL(this.$refs.file.files[0]);
                reader.onload = ()=> {
                    this.news.image = reader.result;
                };
            }
        }
    }
</script>
